import axios from 'axios';

import { IDocumentTelechargement } from '@/shared/model/document-telechargement.model';

const baseApiUrl = 'api/document-telechargements';

export default class DocumentTelechargementService {
  public find(id: number): Promise<IDocumentTelechargement> {
    return new Promise<IDocumentTelechargement>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IDocumentTelechargement): Promise<IDocumentTelechargement> {
    return new Promise<IDocumentTelechargement>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IDocumentTelechargement): Promise<IDocumentTelechargement> {
    return new Promise<IDocumentTelechargement>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
